export default "__VITE_ASSET__81f20208__"